import PasswordChangeLayout from "@layouts/PasswordChangeLayout";
import React from "react";

const ConfirmNewPassword: React.FC = () => {
  return <PasswordChangeLayout resetType="reset_password" />;
};

export default ConfirmNewPassword;
